import { useI18n } from "@/lib/i18n";

export default function LegalPage({ pageKey, testId }) {
  const { t } = useI18n();
  const sectionKeys = {
    privacy: [
      "responsable",
      "datos",
      "finalidad",
      "base",
      "conservacion",
      "terceros",
      "derechos",
      "seguridad",
      "contacto",
    ],
    cookies: ["queSon", "tipos", "consentMode", "gestion", "duracion", "contacto"],
    terms: [
      "aceptacion",
      "servicios",
      "elegibilidad",
      "riesgos",
      "comisiones",
      "propiedad",
      "responsabilidad",
      "jurisdiccion",
      "modificaciones",
      "contacto",
    ],
  };

  const keys = sectionKeys[pageKey] || [];

  return (
    <main data-testid={testId} className="bg-[#F8F9FA]">
      <div className="mx-auto max-w-4xl px-5 md:px-8 py-16 md:py-24">
        <p className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-4">
          {t(`pages.${pageKey}.updated`)}
        </p>
        <h1
          className="text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]"
          style={{ fontFamily: "'Playfair Display', serif", color: "#0D1B2A" }}
        >
          {t(`pages.${pageKey}.title`)}
        </h1>
        <p className="mt-8 text-[#1B263B]/85 text-base leading-relaxed max-w-3xl">
          {t(`pages.${pageKey}.intro`)}
        </p>

        <div className="mt-12 space-y-10">
          {keys.map((k) => (
            <section key={k} data-testid={`section-${pageKey}-${k}`}>
              <h2
                className="text-xl sm:text-2xl tracking-tight"
                style={{ fontFamily: "'Playfair Display', serif", color: "#0D1B2A" }}
              >
                {t(`pages.${pageKey}.sections.${k}.title`)}
              </h2>
              <p className="mt-3 text-[#1B263B]/85 text-base leading-relaxed">
                {t(`pages.${pageKey}.sections.${k}.body`)}
              </p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
